import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Super admins only: red bar while a withheld cross-company result is waiting for review.
export default function MongoAlertBanner() {
    const { user } = useAuth();
    const isSuper = user?.role === "super_admin";
    const location = useLocation();
    const [state, setState] = useState({ count: 0, latest: null });
    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/admin/mongo-mcp/alerts?open=true");
            setState({ count: data.open_count || 0, latest: (data.items || [])[0] || null });
        } catch (e) { /* the banner never blocks the page */ }
    }, []);
    useEffect(() => {
        if (!isSuper) return undefined;
        load();
        const t = setInterval(load, 60000);
        window.addEventListener("mongo-alerts-changed", load);
        return () => { clearInterval(t); window.removeEventListener("mongo-alerts-changed", load); };
    }, [isSuper, load, location.pathname]);
    if (!isSuper || !state.count) return null;
    const a = state.latest;
    return (
        <div className="bg-red-600/15 border-b border-red-500/40 px-6 py-2 flex items-center gap-3 text-xs" data-testid="mongo-alert-banner">
            <ShieldAlert className="w-4 h-4 text-red-400" />
            <span className="text-red-200" data-testid="mongo-alert-banner-text">
                <b>{state.count}</b> MongoDB result{state.count === 1 ? " was" : "s were"} withheld by the company lock
                {a ? ` — latest: ${a.tool} · ${a.database}.${a.collection} · company ${(a.companies || []).join(", ")}` : ""}
            </span>
            <Link to="/settings/mongodb-mcp#alerts" data-testid="mongo-alert-banner-review"
                className="ml-auto px-2.5 py-1 rounded bg-red-500 text-white font-medium hover:bg-red-400 transition-colors">Review</Link>
        </div>
    );
}
